import { TableHeadersConfig } from '../../utils/utils';

export const currentAccountsTableConfig: TableHeadersConfig[] = [
  {
    title: '#',
  },
  {
    title: 'Owner',
    sortingKey: 'firstName',
  },
  {
    title: 'Check In',
    sortingKey: 'checkIn',
  },
  {
    title: 'Check Out',
    sortingKey: 'checkOut',
  },
  {
    title: 'Room',
    sortingKey: 'room',
  },
  {
    title: 'Notes',
    sortingKey: 'notes',
  },
  {
    title: 'Action',
  },
];



// WEBPACK FOOTER //
// ./src/pages/current-accounts/currentAccountsTableConfig.ts